export default {
  getRestaurantMeal: "GET_RESTAURANT_MEAL",
  getRestaurantMealSuccess: "GET_RESTAURANT_MEAL_SUCCESS",
  getRestaurantMealFailed: "GET_RESTAURANT_MEAL_FAILED",
  updateMealStatus: "UPDATE_MEAL_STATUS",
  updateMealStatusSuccess: "UPDATE_MEAL_STATUS_SUCCESS",
  updateMealStatusFailure: "UPDATE_MEAL_STATUS_FAILURE",
  addRestaurantMeal: "ADD_RESTAURANT_MEAL",
  addRestaurantMealSuccess: "ADD_RESTAURANT_MEAL_SUCCESS",
  addRestaurantMealFailure: "ADD_RESTAURANT_MEAL_FAILURE",
  editRestaurantMeal: "EDIT_RESTAURANT_MEAL",
  editRestaurantMealSuccess: "EDIT_RESTAURANT_MEAL_SUCCESS",
  editRestaurantMealFailure: "EDIT_RESTAURANT_MEAL_FAILURE",
};
